<h2 mat-dialog-title>{{ 'mark_as_paid' | translate }}</h2>
<div mat-dialog-content>
    <table appFieldContainer>
        <div>
            <mat-checkbox [(ngModel)]="data.sendToBusinessForPreparation">
                {{ 'send_to_business_for_preparation' | translate }}
            </mat-checkbox>
        </div>
    </table>
</div>
<div mat-dialog-actions align="end">
    <button mat-button [disabled]="!isValidDialogData()" [mat-dialog-close]="data">{{ 'ok' | translate }}</button>
    <button mat-button (click)="closeDialog()">{{ 'cancel' | translate }}</button>
</div>
